import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http'


@Injectable()
export class HttpService {

	constructor() {

	}

	sendForm( data:object, file: File ):FormData{
		var formData = new FormData();
		if(data != null){
			let key:keyof object;
			for (const [k, v] of Object.entries(data)) {
				if (k == "productos" || k == "servicios" || k == "tipoVenta" || k == "corte") {
					formData.append(k,JSON.stringify(v))
				}else{
					formData.append(k,v)
				}
			}
		}

		if(file != null){
			formData.append('file',file,file.name)
		}
		
		return formData;
	}


	headerOptionsJson(sendToken:boolean, isGet:boolean):object {

		let httpOptions:object;
		let headers = new HttpHeaders();
		let params = new HttpParams();

		if (sendToken) {
			let token = localStorage.getItem("JWT");
			if (token != null ) headers = headers.set("Token", token);
		}

		if (!isGet) {
			headers = headers.set("Content-Type", "application/json; charset=utf-8");
		}
		
		httpOptions = { headers: headers};

		return httpOptions;
	}

	// headerOptionsRefreshJson(sendToken:boolean, isGet:boolean):object {

	// 	let httpOptions:object;
	// 	let headers = new HttpHeaders();

	// 	if (sendToken) {
	// 		let token = localStorage.getItem("refresh_token");
	// 		if (token != null ) headers = headers.set("Authorization", "Bearer " +token);
	// 	}
		
	// 	if (!isGet) {
	// 		headers = headers.set("Content-Type", "application/json; charset=utf-8");
	// 	}
		
	// 	httpOptions = { headers: headers };

	// 	return httpOptions;
	// }

	// headerOptionsUrlenconde(sendToken:boolean, isGet:boolean):object {

	// 	let httpOptions:object;
	// 	let headers = new HttpHeaders();

	// 	if (sendToken) {
	// 		let token = localStorage.getItem("JWT");
	// 		if (token != null ) headers = headers.set("Authorization", "Bearer " +token);
	// 	}
		
	// 	if (!isGet) {
	// 		headers = headers.set("Content-Type", "application/x-www-form-urlencoded");
	// 	}
		
	// 	httpOptions = { headers: headers };

	// 	return httpOptions;
	// }


	headerOptionsForm(sendToken:boolean):object {
		let httpOptions:object;
		
		let headers = new HttpHeaders();

		if (sendToken) {
			let token = localStorage.getItem("JWT");
			if (token != null ) headers = headers.set("Token", token);
		}
		
		httpOptions = { headers: headers };
		return httpOptions;
	}

}